module.exports = __webpack_public_path__ + "static/media/experience-unforgettable-experiences.6cf86263.webp";